import { Globe2, MapPin, DollarSign } from "lucide-react";
import { marketPoints, whyGeodyn, MARKET_IMG } from "@/content";
import { Reveal, Overline } from "@/components/site/Reveal";

const micons = [Globe2, MapPin, DollarSign];

export const Market = () => (
  <section id="market" data-testid="market-section" className="relative py-28 bg-surface/40 border-t border-white/5">
    <div className="mx-auto max-w-7xl px-6 grid lg:grid-cols-2 gap-16 items-start">
      <Reveal>
        <div className="lg:sticky lg:top-28 relative rounded-2xl overflow-hidden border border-white/10">
          <img src={MARKET_IMG} alt="Modern parking structure illuminated at night" className="w-full h-[560px] object-cover" />
          <div className="absolute inset-0 bg-gradient-to-t from-ink via-ink/30 to-transparent" />
          <div className="absolute bottom-6 left-6 right-6">
            <div className="font-mono text-[11px] tracking-widest uppercase text-brand-green">Total Potential Market</div>
            <div className="mt-1 font-heading font-extrabold text-4xl text-white">$100B+</div>
            <div className="text-sm text-white/60">Global parking, ripe for a smarter layer.</div>
          </div>
        </div>
      </Reveal>

      <div>
        <Reveal>
          <Overline>Market Opportunity</Overline>
          <h2 className="mt-4 font-heading font-extrabold text-4xl sm:text-5xl tracking-tight">
            A massive, <span className="text-brand-green">underserved</span> market.
          </h2>
          <div className="mt-8 space-y-4">
            {marketPoints.map((m, i) => {
              const Icon = micons[i];
              return (
                <div key={i} className="flex items-center gap-4 rounded-xl border border-white/10 bg-ink/60 p-5">
                  <Icon className="h-6 w-6 text-brand-green shrink-0" />
                  <span className="text-white/80">{m}</span>
                </div>
              );
            })}
          </div>
        </Reveal>

        <Reveal delay={0.15}>
          <div className="mt-14">
            <Overline>Why GeoDyn</Overline>
            <h3 className="mt-4 font-heading font-extrabold text-3xl sm:text-4xl tracking-tight">
              We optimize. <span className="text-gradient">Others just process.</span>
            </h3>
            <ul className="mt-6 space-y-4">
              {whyGeodyn.map((w, i) => (
                <li key={i} className="flex items-start gap-3">
                  <span className="mt-1.5 h-2 w-2 rounded-full bg-brand-green shrink-0 shadow-[0_0_8px_rgba(141,198,63,0.8)]" />
                  <span className="text-white/80">{w}</span>
                </li>
              ))}
            </ul>
            <p className="mt-6 text-sm text-white/50">
               Third parties focus on payments. GeoDyn focuses on intelligence & optimization, and we make every system smarter.
            </p>
          </div>
        </Reveal>
      </div>
    </div>
  </section>
);
